export default __webpack_public_path__ + "static/media/1794.1485e386.jpg";